import { styled } from 'styletron-react';

const FormGroupRoot = styled('div', ({ $theme }) => ({
  width: '100%',
  marginBottom: `${$theme.spacing(2)}px`,
}));

export default FormGroupRoot;
